export function renderGalleryFieldFormFieldTemplate({
  indent,
  fieldName,
  formItemProps,
  labelWithDescription,
  onChange,
  maxItemsProp
}: {
  indent: string
  fieldName: string
  formItemProps: string
  labelWithDescription: string
  onChange: string
  maxItemsProp: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}"
${indent}  render={({ field: formField }) => (
${indent}    <FormItem${formItemProps}>
${indent}      ${labelWithDescription}
${indent}      <FormControl>
${indent}        <GalleryField
${indent}          value={formField.value}
${indent}          onChange={${onChange}}
${indent}          disabled={isPending}${maxItemsProp}
${indent}        />
${indent}      </FormControl>
${indent}      <FormMessage />
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}
